// @flow
import moment from 'moment';

export const MAX_OFFERS = 3;

// ENG-31244 — hours-from-now per property quote-expiration setting, mirroring the backend's
// src/utils/quoteExpiration.js so the pre-populated value here agrees with the server's
// authoritative one (which ignores whatever the client actually submits).
export const QUOTE_EXPIRATION_HOURS = {
  SAME_DAY: 0,
  HOURS_24: 24,
  HOURS_48: 48,
  HOURS_72: 72,
};

export const getOfferExpirationDate = (quoteExpTime: ?string): Date =>
  moment()
    .add(QUOTE_EXPIRATION_HOURS[quoteExpTime] ?? 0, 'hours')
    .startOf('day')
    .toDate();

export const TRANSACTION_TYPE_OPTIONS = [
  { value: 'default', text: 'Choose', disabled: true },
  { value: 'Charge', text: 'Charge' },
  { value: 'Credit', text: 'Credit' },
];

export const mapTransactionCodesToOptions = (
  transactionCodes: Array<Object>,
) => {
  const codes = transactionCodes.map((txCode) => ({
    value: txCode.transactionCode.id,
    text: txCode.transactionCode.code,
  }));
  codes.unshift({ value: 'default', text: 'Choose', disabled: true });
  return codes;
};
